import { LeapmotorFileDTO } from "./file-dto";

export class LeapmotorMktCoopActionDTO {
    IdAction: string | null;
    IdAnimation: number;
    IdDistributor: number;
    IdType: number;
    IdMedia: number;
    Media: string;
    Type: string;
    IdStatus: number;
    ExpectedAmount: number;
    InitDate: string | null;
    EndDate: string | null;
    FileAction: LeapmotorFileDTO | null;
    FileSupplyerInvoice: LeapmotorFileDTO | null;
    FileLeapmotorInvoice: LeapmotorFileDTO | null;
    FileEvidence: LeapmotorFileDTO | null;
    InvoiceNumber: string;
    InvoiceDate: string | null;
    InvoiceConcept: string;
    LeapmotorSubvention: number | null;
    SupplierInvoiceAmount: number | null;
    LeapInvoiceAmount: number | null;
    Comments: MktCoopActionComment[] | null;
    ActualComment: string;
    Status: string;
    DistributorName: string;
    DistributorCode: string;
    WihtinExtraDays: boolean;
}

export class MktCoopActionComment {
    Status: string;
    User: string;
    Distributor: string;
    Comment: string | null;
    Date: string;
}

export class LeapmotorMktCoopActionPostDTO {
    IdAnimation: number;
    IdDistributor: number;
    IdType: number;
    IdMedia: number;
    IdStatus: number;
    ExpectedAmount: number;
    InitDate: string | null;
    EndDate: string | null;
    FileAction: File | null;
    FileSupplyerInvoice: File | null;
    FileLeapmotorInvoice: File | null;
    FileEvidence: File | null;
    InvoiceNumber: string | null;
    InvoiceDate: string | null;
    InvoiceConcept: string | null;
    LeapmotorSubvention: number | null;
    SupplierInvoiceAmount: number | null;
    LeapInvoiceAmount: number | null;
    Log: LeapmotorMktCoopActionLogDTO | null;
}

export class LeapmotorMktCoopActionChangeAnimationDTO {
    IdAnimation: number;
    InitDate: string | null;
    EndDate: string | null;
}

export class MktCoopActionFilters {
    IdDistributor: number | null = null;
    IdAnimation: number | null = null;
    IdType: number | null = null;
    IdMedia: number | null = null;
    IdStatus: number | null = null;
    Year: number | null = null;
    Month: number | null = null;

    hasAnyValueSet(): boolean {
        return Object.values(this).some(value => value !== null);
      }
}

export class LeapmotorMktCoopActionLogDTO {
    comment: string | null;
}

export class MktCoopBudgetResult {
    IdType: number;
    Type: string;
    TotalBudgetString: string;
    TotalBudget: number;
    TotalSpentConf: number;
    TotalSpentProv: number;
    SpentConfPercent: number | null;
    SpentProvPercent: number | null;
    RemainConf: number;
    RemainConfString: string;
    ProvGraph: MktCoopBudgetGraph[];
    ConfGraph: MktCoopBudgetGraph[];
}

export class MktCoopBudgetGraph {
    name: string;
    y: number;
}